import { render, staticRenderFns } from "./roads-need-construction.vue?vue&type=template&id=3d0fec67"
import script from "./roads-need-construction.vue?vue&type=script&lang=js"
export * from "./roads-need-construction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports